// @flow

import _ from 'lodash';
import ApiObject from './ApiObject';
import Payment from './Payment';

export default class PaymentsList extends ApiObject {
  payments: Array<Payment> = [];

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize payments
    this.payments = [];

    // -- handle the case were the api responds a json with the array directly.
    let dataPayments = [];
    if (!_.isUndefined(data.payments)) {
      dataPayments = data.payments;
    } else {
      dataPayments = data;
    }

    _.each(dataPayments, (paymentData: Object) => {
      const payment:Payment = new Payment();
      payment.fromJson(paymentData);
      this.payments.push(payment);
    });
  }

  findById(idToFind: string): ?Payment {
    const found = _.find(this.payments, (payment: Payment): boolean => {
      return payment.id === idToFind;
    });

    if (_.isUndefined(found)) {
      return null;
    }

    return found;
  }

  count() {
    return this.payments.length;
  }

  getLastVisitFormatted() {
    return `${this.payments[0].getFormattedDate()} - ${this.payments[0].getFormattedHour()}`;
  }

  getAveragePayment() {
    let total = 0;
    _.each(this.payments, (payment: Payment) => {
      total += payment.amount;
    });

    if (this.count() === 0) {
      return 0;
    }

    return total / this.count();
  }

  getAverageTip() {
    let total = 0;
    _.each(this.payments, (payment: Payment) => {
      total += payment.tip;
    });

    if (this.count() === 0) {
      return 0;
    }
    return total / this.count();
  }

}
